import { supabase } from "../../../auth/supabaseClient";
import {
  fetchOrganizationAccess,
  updateOrganizationSettings,
} from "../../../core/settings/organizationAccessService";
import {
  fetchPlatformBrandAssets,
  getEduSystemAppBrandColor,
  getEduSystemAppBrandIcon,
} from "../../admin/services/platformBrandingService";
import mailIconAsset from "../../../assets/logos/mail icon.png";
import pagesIconAsset from "../../../assets/logos/Pages Icon.png";
import tablesIconAsset from "../../../assets/logos/Tables icon.png";
import classroomIconAsset from "../../../assets/logos/classroom icon.png";
import hallPassIconAsset from "../../../assets/logos/Hall Pass Icon.png";

const APPS_TABLE = "edu_student_device_apps";
const SYSTEM_APPS_TABLE = "edu_student_device_system_apps";
const STUDENTS_TABLE = "edu_student_device_students";
const INSTALLED_APPS_TABLE = "edu_student_device_installed_apps";
const SESSIONS_TABLE = "edu_student_device_sessions";
const DEVICES_TABLE = "edu_student_devices";
const APP_ACTIVITY_TABLE = "edu_student_device_app_activity";
const DEVICE_LOGIN_HISTORY_TABLE = "edu_student_device_login_history";
const TEACHERS_TABLE = "edu_teachers";
const TEACHER_STUDENTS_TABLE = "edu_teacher_students";
const TESTING_CATALOG_TABLE = "edu_testing_app_catalog";
const HALL_PASS_REQUESTS_TABLE = "edu_hall_pass_requests";
const ACCOUNTS_TABLE = "accounts";
const PAGES_DOCUMENTS_TABLE = "pages_documents";
const ORGANIZATION_BUCKET = "organization-assets";
const EDU_MODE = "edu";
const MAX_DEVICE_DOCK_APP_IDS = 6;
const TEACHER_SESSION_STORAGE_KEY = "oikos.edu.teacherSessionToken";
const DEVICE_BRAND_COLOR = "#d75c37";
const DEFAULT_DEVICE_BACKGROUND = {
  imageUrl: "",
  color: "#f8f9fb",
};
const DEFAULT_LOGIN_BACKGROUND = {
  imageUrl: "",
  color: "#f8f9fb",
  useDeviceBackground: true,
};
const DEFAULT_DEVICE_SECURITY = {
  idleLogoutMinutes: 0,
};
export const DEFAULT_STUDENT_DEVICE_PIN = "0316";
const DEFAULT_CHROME_EXTENSION = {
  enabled: true,
  oikosHomeUrl: "",
  googleCustomerId: "",
  googleAdminEmail: "",
  googleOrgUnitPath: "",
  extensionId: "",
  extensionUpdateUrl: "https://clients2.google.com/service/update2/crx",
  allowedHosts: [],
  blockUnknownHosts: true,
  overlayEnabled: true,
};
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DEFAULT_HALL_PASS_SETTINGS = {
  enabled: false,
  destinations: ["Restroom", "Nurse", "Office", "Library"],
  schools: [],
  requireReason: false,
  allowStudentCancel: true,
  dailyPassLimit: 5,
  activePassLimit: 1,
  campusEnabled: false,
  campusLaunchUrl: "",
};
const DEFAULT_EXTRAS_SETTINGS = {
  notificationsEnabled: true,
  managedDevicesEnabled: true,
  hallPassEnabled: false,
  classroomEnabled: false,
  workspaceEnabled: false,
};
const DEFAULT_WORKSPACE_SETTINGS = {
  enabled: false,
  apps: {
    pages: true,
    tables: false,
    slides: false,
    mail: false,
    classroom: false,
    hallPass: false,
    teacherBoard: false,
  },
  studentSharing: false,
  teacherTemplates: true,
  adminReview: true,
  pagesStudentCreate: true,
  pagesStudentSharing: false,
  pagesMailSend: true,
  pagesClassroomAttach: true,
  tablesStudentCreate: true,
  tablesStudentSharing: false,
  tablesMailSend: true,
  tablesClassroomAttach: true,
  slidesStudentCreate: true,
  slidesStudentSharing: false,
  slidesMailSend: true,
  slidesClassroomAttach: true,
};
const OIKOS_MAIL_SYSTEM_APP = {
  id: "00000000-0000-4000-8000-000000000110",
  app_key: "oikos-mail",
  name: "Oikos Mail",
  url: "/mail",
  logo_url: mailIconAsset,
  color: "#B9A6FF",
  description: "Internal school messaging for Oikos EDU Workspace.",
  sort_order: 110,
  is_system: true,
  source: "system",
};
const OIKOS_PAGES_SYSTEM_APP = {
  id: "00000000-0000-4000-8000-000000000111",
  app_key: "oikos-pages",
  name: "Oikos Pages",
  url: "/pages?studentDevice=1",
  logo_url: pagesIconAsset,
  color: "#385CFF",
  description: "Oikos Pages documents and writing assignments.",
  sort_order: 111,
  is_system: true,
  source: "system",
};
const OIKOS_TABLES_SYSTEM_APP = {
  id: "00000000-0000-4000-8000-000000000112",
  app_key: "oikos-tables",
  name: "Oikos Tables",
  url: "/tables?studentDevice=1",
  logo_url: tablesIconAsset,
  color: "#15803d",
  description: "Oikos Tables spreadsheets, trackers, and classroom records.",
  sort_order: 112,
  is_system: true,
  source: "system",
};
const OIKOS_CLASSROOM_SYSTEM_APP = {
  id: "00000000-0000-4000-8000-000000000109",
  app_key: "oikos-classroom",
  name: "Oikos Classroom",
  url: "/classroom/student",
  logo_url: classroomIconAsset,
  color: "#396CFF",
  description: "Classroom assignments and teacher-managed learning.",
  sort_order: 90,
  is_system: true,
  source: "system",
};
const HALL_PASS_SYSTEM_APP = {
  id: "00000000-0000-4000-8000-000000000108",
  app_key: "hall-pass",
  name: "Hall Pass",
  url: "/edu/hallpass/student",
  logo_url: hallPassIconAsset,
  color: "#B23A3A",
  description: "Student hall pass requests and teacher approvals.",
  sort_order: 80,
  is_system: true,
  source: "system",
};
const DEFAULT_TESTING_APPS = [
  {
    id: "testnav",
    name: "TestNav",
    type: "kiosk-pwa",
    launchUrl: "https://home.testnav.com/",
    launchMode: "new-window",
    logoUrl: "",
    description: "Pearson TestNav kiosk launcher",
    isActive: false,
    sortOrder: 0,
  },
  {
    id: "drc",
    name: "DRC",
    type: "kiosk-pwa",
    launchUrl: "https://cdn-app-prod.drcedirect.com/drc-insight-chromeos-ui/index.html",
    launchMode: "new-window",
    logoUrl: "",
    description: "DRC INSIGHT secure testing launcher",
    isActive: false,
    sortOrder: 1,
  },
  {
    id: "nwea",
    name: "NWEA MAP Growth",
    type: "kiosk-pwa",
    launchUrl: "https://test.mapnwea.org/#/nopopup",
    launchMode: "new-window",
    logoUrl: "",
    description: "NWEA secure testing launcher",
    isActive: false,
    sortOrder: 2,
  },
];

function isEnabledFlag(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

function normalizeLimit(value, fallback = 0) {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.max(0, Math.min(99, Math.round(number)));
}

function getWorkspaceSettingsFromPayload(data = {}) {
  const cachedSession = getStudentDeviceSession();
  const cachedEnrollment = getStudentDeviceEnrollment();
  const account = data?.account || {};
  const integrations = account?.integrations || {};
  const eduStudentDevice = integrations?.eduStudentDevice || {};
  const integrationWorkspace = eduStudentDevice?.integrations?.workspace || {};
  const extras = eduStudentDevice?.extras || account?.extrasSettings || account?.extras_settings || {};
  const workspaceSources = [
    cachedEnrollment?.account?.workspaceSettings,
    cachedEnrollment?.account?.workspace_settings,
    cachedEnrollment?.account?.workspace,
    cachedSession?.account?.workspaceSettings,
    cachedSession?.account?.workspace_settings,
    cachedSession?.account?.workspace,
    account?.workspaceSettings,
    account?.workspace_settings,
    account?.workspace,
    eduStudentDevice?.workspace,
  ].filter(Boolean);
  const mergedWorkspace = workspaceSources.reduce((merged, source) => ({
    ...merged,
    ...source,
    apps: {
      ...(merged.apps || {}),
      ...(source.apps || {}),
    },
  }), {});
  const enabledSource =
    mergedWorkspace.enabled !== undefined
      ? mergedWorkspace.enabled
      : integrationWorkspace.enabled !== undefined
        ? integrationWorkspace.enabled
        : extras.workspaceEnabled ?? extras.workspace_enabled;

  return {
    ...DEFAULT_WORKSPACE_SETTINGS,
    ...mergedWorkspace,
    enabled: isEnabledFlag(enabledSource),
    apps: {
      ...DEFAULT_WORKSPACE_SETTINGS.apps,
      ...(mergedWorkspace.apps || {}),
    },
  };
}

function isSystemAppVisibleForAccount(app = {}, account = {}) {
  if (app.appKey === "hall-pass") {
    const workspaceSettings = getWorkspaceSettingsFromPayload({ account });
    return (
      account?.hallPassSettings?.enabled === true ||
      account?.extrasSettings?.hallPassEnabled === true ||
      (isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.hallPass))
    );
  }

  if (app.appKey === "oikos-classroom") {
    const workspaceSettings = getWorkspaceSettingsFromPayload({ account });
    return (
      account?.integrationSettings?.classroom?.enabled === true ||
      account?.extrasSettings?.classroomEnabled === true ||
      (isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.classroom))
    );
  }

  if (app.appKey === "oikos-mail") {
    const workspaceSettings = getWorkspaceSettingsFromPayload({ account });
    return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.mail);
  }

  if (app.appKey === "oikos-pages") {
    const workspaceSettings = getWorkspaceSettingsFromPayload({ account });
    return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.pages);
  }

  if (app.appKey === "oikos-tables") {
    const workspaceSettings = getWorkspaceSettingsFromPayload({ account });
    return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.tables);
  }

  return true;
}

function isClassroomEnabledForStudentDevicePayload(data = {}) {
  const workspaceSettings = getWorkspaceSettingsFromPayload(data);
  return isEnabledFlag(data?.account?.classroomSettings?.enabled) ||
    isEnabledFlag(data?.account?.integrationSettings?.classroom?.enabled) ||
    isEnabledFlag(data?.account?.extrasSettings?.classroomEnabled) ||
    (isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.classroom)) ||
    (data?.apps || []).some((app) => app?.appKey === "oikos-classroom");
}

function isHallPassEnabledForStudentDevicePayload(data = {}) {
  const workspaceSettings = getWorkspaceSettingsFromPayload(data);
  return isEnabledFlag(data?.account?.hallPassSettings?.enabled) ||
    isEnabledFlag(data?.account?.extrasSettings?.hallPassEnabled) ||
    (isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.hallPass)) ||
    (data?.apps || []).some((app) => app?.appKey === "hall-pass" || app?.app_key === "hall-pass");
}

function isMailEnabledForStudentDevicePayload(data = {}) {
  if ((data?.apps || []).some((app) => app?.appKey === "oikos-mail" || app?.app_key === "oikos-mail")) {
    return true;
  }

  const workspaceSettings = getWorkspaceSettingsFromPayload(data);
  return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.mail);
}

function includeMailSystemAppWhenEnabled(apps = [], data = {}, platformBrandAssets = {}) {
  const normalizedApps = Array.isArray(apps) ? apps.map((app) => normalizeApp(app, platformBrandAssets)) : [];
  if (
    !isMailEnabledForStudentDevicePayload(data) ||
    normalizedApps.some((app) => app.appKey === OIKOS_MAIL_SYSTEM_APP.app_key)
  ) {
    return normalizedApps;
  }

  return [
    ...normalizedApps,
    normalizeApp({ ...OIKOS_MAIL_SYSTEM_APP, is_system: true, source: "system" }, platformBrandAssets),
  ];
}

function isPagesEnabledForStudentDevicePayload(data = {}) {
  if ((data?.apps || []).some((app) => app?.appKey === "oikos-pages" || app?.app_key === "oikos-pages")) {
    return true;
  }

  const workspaceSettings = getWorkspaceSettingsFromPayload(data);
  return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.pages);
}

function isTablesEnabledForStudentDevicePayload(data = {}) {
  if ((data?.apps || []).some((app) => app?.appKey === "oikos-tables" || app?.app_key === "oikos-tables")) {
    return true;
  }

  const workspaceSettings = getWorkspaceSettingsFromPayload(data);
  return isEnabledFlag(workspaceSettings.enabled) && isEnabledFlag(workspaceSettings.apps?.tables);
}

function includeWorkspaceSystemAppsWhenEnabled(apps = [], data = {}, platformBrandAssets = {}) {
  let normalizedApps = includeMailSystemAppWhenEnabled(apps, data, platformBrandAssets);
  if (
    isPagesEnabledForStudentDevicePayload(data) &&
    !normalizedApps.some((app) => app.appKey === OIKOS_PAGES_SYSTEM_APP.app_key)
  ) {
    normalizedApps = [
      ...normalizedApps,
      normalizeApp({ ...OIKOS_PAGES_SYSTEM_APP, is_system: true, source: "system" }, platformBrandAssets),
    ];
  }
  if (
    isTablesEnabledForStudentDevicePayload(data) &&
    !normalizedApps.some((app) => app.appKey === OIKOS_TABLES_SYSTEM_APP.app_key)
  ) {
    normalizedApps = [
      ...normalizedApps,
      normalizeApp({ ...OIKOS_TABLES_SYSTEM_APP, is_system: true, source: "system" }, platformBrandAssets),
    ];
  }

  return normalizedApps;
}

function includeCoreSystemApps(apps = [], data = {}, platformBrandAssets = {}) {
  let normalizedApps = includeWorkspaceSystemAppsWhenEnabled(apps, data, platformBrandAssets);

  if (
    isHallPassEnabledForStudentDevicePayload(data) &&
    !normalizedApps.some((app) => app.appKey === HALL_PASS_SYSTEM_APP.app_key)
  ) {
    normalizedApps = [
      ...normalizedApps,
      normalizeApp({ ...HALL_PASS_SYSTEM_APP, is_system: true, source: "system" }, platformBrandAssets),
    ];
  }

  if (
    isClassroomEnabledForStudentDevicePayload(data) &&
    !normalizedApps.some((app) => app.appKey === OIKOS_CLASSROOM_SYSTEM_APP.app_key)
  ) {
    normalizedApps = [
      ...normalizedApps,
      normalizeApp({ ...OIKOS_CLASSROOM_SYSTEM_APP, is_system: true, source: "system" }, platformBrandAssets),
    ];
  }

  return normalizedApps;
}

function getCachedEduAccount() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem("oikos.organization.edu");
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

function getEduAppOrigin() {
  if (typeof window === "undefined") return "https://oikosedu.app";

  const hostname = String(window.location.hostname || "").toLowerCase();
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname.endsWith(".local")) {
    return window.location.origin;
  }

  return "https://oikosedu.app";
}

function normalizeLoginName(name = "") {
  return String(name || "").trim().toLowerCase();
}

function normalizeStudentLoginName(name = "") {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[\s.]+/g, "")
    .replace(/[^a-z0-9_-]+/g, "")
    .slice(0, 64);
}

function normalizeApp(row = {}, platformBrandAssets = {}) {
  const createdByTeacherId = row.created_by_teacher_id || row.createdByTeacherId || "";
  const createdByTeacherName =
    row.created_by_teacher_name ||
    row.createdByTeacherName ||
    row.teacher_name ||
    row.teacherName ||
    row.teacher?.display_name ||
    row.teacher?.displayName ||
    "";
  const appKey = row.app_key || row.appKey || "";
  const defaultLogoUrl =
    appKey === OIKOS_MAIL_SYSTEM_APP.app_key ? OIKOS_MAIL_SYSTEM_APP.logo_url :
    appKey === OIKOS_PAGES_SYSTEM_APP.app_key ? OIKOS_PAGES_SYSTEM_APP.logo_url :
    appKey === OIKOS_TABLES_SYSTEM_APP.app_key ? OIKOS_TABLES_SYSTEM_APP.logo_url :
    appKey === OIKOS_CLASSROOM_SYSTEM_APP.app_key ? OIKOS_CLASSROOM_SYSTEM_APP.logo_url :
    appKey === HALL_PASS_SYSTEM_APP.app_key ? HALL_PASS_SYSTEM_APP.logo_url :
    "";
  const logoUrl = getEduSystemAppBrandIcon(
    platformBrandAssets,
    appKey,
    defaultLogoUrl || row.logo_url || row.logoUrl
  );
  return {
    id: row.id || "",
    appKey,
    accountId: row.account_id || "",
    createdByTeacherId,
    createdByTeacherName,
    name: row.name || "",
    url: row.url || "",
    logoUrl,
    color: getEduSystemAppBrandColor(platformBrandAssets, appKey, row.color || DEVICE_BRAND_COLOR),
    isActive: row.is_active !== false,
    sortOrder: Number(row.sort_order || 0),
    description: row.description || "",
    isSystem: row.is_system === true || row.isSystem === true || row.source === "system",
    source: row.source || (row.is_system || row.isSystem ? "system" : createdByTeacherId ? "teacher" : "admin"),
  };
}

function normalizeTestingAppConfig(app = {}, index = 0) {
  return {
    ...app,
    id: String(app.id || app.name || `testing-${index + 1}`).trim().toLowerCase().replace(/[^a-z0-9-]+/g, "-"),
    name: String(app.name || "").trim(),
    type: String(app.type || "kiosk-pwa").trim() || "kiosk-pwa",
    launchUrl: String(app.launchUrl || app.launch_url || app.url || "").trim(),
    launchMode: String(app.launchMode || app.launch_mode || "new-window").trim() || "new-window",
    logoUrl: String(app.logoUrl || app.logo_url || app.iconUrl || app.imageUrl || app.logo || "").trim(),
    description: String(app.description || "").trim(),
    isActive: app.isActive === true || app.is_active === true,
    sortOrder: Number(app.sortOrder ?? app.sort_order ?? index),
  };
}

function normalizeTestingApps(apps = []) {
  return Array.isArray(apps)
    ? apps.map(normalizeTestingAppConfig).filter((app) => app.name && app.launchUrl)
    : [];
}

function normalizeTestingAppSettings(settings = []) {
  return Array.isArray(settings)
    ? settings
        .map((app) => ({
          id: String(app?.id || "").trim().toLowerCase(),
          isActive: app?.isActive === true,
        }))
        .filter((app) => app.id)
    : [];
}

function normalizeNotificationTemplate(template = {}, index = 0) {
  const id = String(template.id || template.name || `notification-${index + 1}`)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return {
    id: id || `notification-${index + 1}`,
    name: String(template.name || template.title || "").trim(),
    title: String(template.title || "").trim(),
    message: String(template.message || "").trim(),
    isActive: template.isActive !== false && template.is_active !== false,
    sortOrder: Number(template.sortOrder ?? template.sort_order ?? index),
  };
}

function normalizeNotificationTemplates(templates = []) {
  return Array.isArray(templates)
    ? templates
        .map(normalizeNotificationTemplate)
        .filter((template) => template.name && template.title && template.message)
        .sort((first, second) => first.sortOrder - second.sortOrder || first.name.localeCompare(second.name))
    : [];
}

function mergeDefaultTestingApps(apps = [], settings = []) {
  const normalizedApps = normalizeTestingApps(
    Array.isArray(apps) && apps.length > 0 ? apps : DEFAULT_TESTING_APPS
  );
  const activeSettings = new Map(normalizeTestingAppSettings(settings).map((app) => [app.id, app.isActive]));
  const existingIds = new Set(normalizedApps.map((app) => app.id));
  const missingDefaults = DEFAULT_TESTING_APPS.filter((app) => !existingIds.has(app.id));

  return [...normalizedApps, ...missingDefaults]
    .map((app, index) => {
      const normalizedApp = normalizeTestingAppConfig(app, index);
      return {
        ...normalizedApp,
        isActive: activeSettings.has(normalizedApp.id)
          ? activeSettings.get(normalizedApp.id)
          : normalizedApp.isActive === true,
      };
    })
    .sort((first, second) => first.sortOrder - second.sortOrder || first.name.localeCompare(second.name));
}

function normalizeEduAccount(row = {}) {
  const integrations = row.integrations || {};
  const deviceBackground =
    integrations?.eduStudentDevice?.background ||
    row.deviceBackground ||
    DEFAULT_DEVICE_BACKGROUND;
  const loginBackground =
    integrations?.eduStudentDevice?.loginBackground ||
    row.deviceLoginBackground ||
    DEFAULT_LOGIN_BACKGROUND;
  const campusLoginBackground =
    integrations?.campus?.loginBackground ||
    row.campusLoginBackground ||
    {};
  const deviceDockAppIds =
    integrations?.eduStudentDevice?.dockAppIds ||
    row.deviceDockAppIds ||
    [];
  const idleLogoutMinutes = Number(
    integrations?.eduStudentDevice?.idleLogoutMinutes ??
      row.idleLogoutMinutes ??
      DEFAULT_DEVICE_SECURITY.idleLogoutMinutes
  );
  const chromeExtension = {
    ...DEFAULT_CHROME_EXTENSION,
    ...(integrations?.eduStudentDevice?.chromeExtension || row.chromeExtension || {}),
  };
  const testingApps = row.testingApps || DEFAULT_TESTING_APPS;
  const testingAppSettings =
    integrations?.eduStudentDevice?.testingAppSettings ||
    integrations?.eduStudentDevice?.testingApps ||
    [];
  const hallPassSettings = {
    ...DEFAULT_HALL_PASS_SETTINGS,
    ...(integrations?.eduStudentDevice?.hallPass || row.hallPassSettings || {}),
  };
  const extrasSource = integrations?.eduStudentDevice?.extras || row.extrasSettings || {};
  const integrationSettings = integrations?.eduStudentDevice?.integrations || {};
  const workspaceSource = integrations?.eduStudentDevice?.workspace || {};
  const workspaceIntegration = integrationSettings.workspace || {};
  const workspaceEnabledSource =
    workspaceIntegration.enabled !== undefined
      ? workspaceIntegration.enabled
      : workspaceSource.enabled !== undefined
        ? workspaceSource.enabled
        : extrasSource.workspaceEnabled;
  const extrasSettings = {
    ...DEFAULT_EXTRAS_SETTINGS,
    ...extrasSource,
    notificationsEnabled: true,
    managedDevicesEnabled:
      extrasSource.managedDevicesEnabled !== undefined
        ? isEnabledFlag(extrasSource.managedDevicesEnabled)
        : extrasSource.managed_devices_enabled !== undefined
          ? isEnabledFlag(extrasSource.managed_devices_enabled)
          : true,
    hallPassEnabled:
      extrasSource.hallPassEnabled !== undefined
        ? isEnabledFlag(extrasSource.hallPassEnabled)
        : isEnabledFlag(hallPassSettings.enabled),
    classroomEnabled: isEnabledFlag(
      integrations?.eduStudentDevice?.integrations?.classroom?.enabled ||
        extrasSource.classroomEnabled
    ),
    workspaceEnabled: isEnabledFlag(workspaceEnabledSource),
  };
  const workspaceSettings = {
    ...DEFAULT_WORKSPACE_SETTINGS,
    ...workspaceSource,
    enabled: isEnabledFlag(workspaceEnabledSource),
    apps: {
      ...DEFAULT_WORKSPACE_SETTINGS.apps,
      ...(workspaceSource.apps || {}),
      teacherBoard: workspaceSource.apps?.teacherBoard === true,
    },
    studentSharing: isEnabledFlag(workspaceSource.studentSharing),
    teacherTemplates:
      workspaceSource.teacherTemplates !== undefined
        ? isEnabledFlag(workspaceSource.teacherTemplates)
        : DEFAULT_WORKSPACE_SETTINGS.teacherTemplates,
    adminReview:
      workspaceSource.adminReview !== undefined
        ? isEnabledFlag(workspaceSource.adminReview)
        : DEFAULT_WORKSPACE_SETTINGS.adminReview,
  };
  const notificationTemplates = normalizeNotificationTemplates(
    integrations?.eduStudentDevice?.notificationTemplates || row.notificationTemplates || []
  );
  const deviceCode = row.edu_device_code || row.deviceCode || "";
  const portalUrls = {
    devicesAdmin: "/devices/admin",
    devicesTeacher: deviceCode ? `/devices/teacher/${deviceCode}` : "/devices/teacher",
    devicesStudent: deviceCode ? `/devices/student/${deviceCode}` : "/devices/student",
    hallPassAdmin: deviceCode ? `/edu/hallpass/admin/${deviceCode}` : "/edu/hallpass/admin",
    hallPassTeacher: deviceCode ? `/edu/hallpass/teacher/${deviceCode}` : "/edu/hallpass/teacher",
    hallPassStudent: deviceCode ? `/edu/hallpass/student/${deviceCode}` : "/edu/hallpass/student",
    classroomAdmin: "/classroom/admin",
    classroomTeacher: deviceCode ? `/classroom/teacher/${deviceCode}` : "/classroom/teacher",
    classroomStudent: deviceCode ? `/classroom/student/${deviceCode}` : "/classroom/student",
    workspaceAdmin: "/workspace/admin",
    workspacePages: "/pages",
    workspaceTables: "/tables",
    workspaceSlides: "/slides",
    workspaceMail: "/mail",
    teacherBoardAdmin: "/workspace/admin?section=teacherBoard",
    ...(row.portalUrls || row.portal_urls || {}),
  };

  return row?.id
    ? {
        ...row,
        id: row.id || "",
        name: row.name || "",
        logo_url: row.logo_url || "",
        logo_path: row.logo_path || "",
        brand_color: row.brand_color || "",
        integrations,
        deviceBackground: {
          imageUrl: deviceBackground.imageUrl || "",
          color: deviceBackground.color || DEFAULT_DEVICE_BACKGROUND.color,
        },
        deviceLoginBackground: {
          imageUrl: loginBackground.imageUrl || "",
          color: loginBackground.color || deviceBackground.color || DEFAULT_LOGIN_BACKGROUND.color,
          useDeviceBackground: loginBackground.useDeviceBackground !== false,
        },
        campusLoginBackground: {
          imageUrl: campusLoginBackground.imageUrl || "",
          color: campusLoginBackground.color || "#fff7ed",
        },
        deviceDockAppIds: Array.isArray(deviceDockAppIds)
          ? deviceDockAppIds.filter(Boolean).slice(0, MAX_DEVICE_DOCK_APP_IDS)
          : [],
        idleLogoutMinutes: Number.isFinite(idleLogoutMinutes)
          ? Math.max(0, Math.min(240, idleLogoutMinutes))
          : DEFAULT_DEVICE_SECURITY.idleLogoutMinutes,
        chromeExtension: {
          ...chromeExtension,
          allowedHosts: Array.isArray(chromeExtension.allowedHosts)
            ? chromeExtension.allowedHosts.filter(Boolean)
            : [],
        },
        testingApps: mergeDefaultTestingApps(testingApps, testingAppSettings),
        hallPassSettings: {
          ...hallPassSettings,
          enabled: extrasSettings.hallPassEnabled === true,
          destinations: Array.isArray(hallPassSettings.destinations)
            ? hallPassSettings.destinations.map((destination) => String(destination || "").trim()).filter(Boolean)
            : DEFAULT_HALL_PASS_SETTINGS.destinations,
          dailyPassLimit: normalizeLimit(hallPassSettings.dailyPassLimit, DEFAULT_HALL_PASS_SETTINGS.dailyPassLimit),
          activePassLimit: normalizeLimit(hallPassSettings.activePassLimit, DEFAULT_HALL_PASS_SETTINGS.activePassLimit),
          schools: Array.isArray(hallPassSettings.schools)
            ? hallPassSettings.schools.map((schoolName) => String(schoolName || "").trim()).filter(Boolean)
            : [],
        },
        extrasSettings,
        integrationSettings,
        workspaceSettings,
        notificationTemplates,
        deviceCode,
        portalUrls,
      }
    : null;
}

function normalizeHallPassRequest(row = {}) {
  return {
    id: row.id || "",
    accountId: row.account_id || row.accountId || "",
    studentId: row.student_id || row.studentId || "",
    studentName: row.student_name || row.studentName || "",
    teacherId: row.teacher_id || row.teacherId || "",
    teacherName: row.teacher_name || row.teacherName || "",
    destination: row.destination || "",
    note: row.note || "",
    status: row.status || "requested",
    campusSyncStatus: row.campus_sync_status || row.campusSyncStatus || "",
    campusSyncPayload: row.campus_sync_payload || row.campusSyncPayload || {},
    createdAt: row.created_at || row.createdAt || "",
    updatedAt: row.updated_at || row.updatedAt || "",
    resolvedAt: row.resolved_at || row.resolvedAt || "",
  };
}

function getEffectiveStudentThemeColor(themeColor = "", accountColor = "") {
  const cleanTheme = String(themeColor || "").trim();
  const cleanAccountColor = String(accountColor || "").trim();

  if (cleanTheme && cleanTheme.toLowerCase() !== DEVICE_BRAND_COLOR.toLowerCase()) {
    return cleanTheme;
  }

  return cleanAccountColor || DEVICE_BRAND_COLOR;
}

function buildStudentDeviceActivityError(error) {
  const message = String(error?.message || error || "").trim();
  const details = String(error?.details || "").trim();
  const hint = String(error?.hint || "").trim();
  const code = String(error?.code || "").trim();
  const original = [code, message, details, hint].filter(Boolean).join(" - ");
  const combined = `${message} ${details} ${hint} ${code}`.toLowerCase();

  if (combined.includes("edu_student_device_record_app_launch") || combined.includes("function") || combined.includes("schema cache")) {
    return new Error(`App activity tracking is not enabled in this Supabase project yet. Run sql/edu-student-device-app-activity.sql, then try opening an app again. Supabase said: ${original || "function missing"}`);
  }

  if (combined.includes("operator does not exist") || combined.includes("42883")) {
    return new Error(`App activity tracking needs the latest SQL update. Run sql/edu-student-device-app-activity.sql in Supabase, then try opening an app again. Supabase said: ${original || "type mismatch"}`);
  }

  if (combined.includes("edu_student_device_app_activity") || combined.includes("relation") || combined.includes("does not exist")) {
    return new Error(`The app activity table is missing in this Supabase project. Run sql/edu-student-device-app-activity.sql, then try opening an app again. Supabase said: ${original || "table missing"}`);
  }

  if (combined.includes("invalid student device session")) {
    return new Error("App activity was not recorded because this student session is no longer active. Sign out and back in, then try again.");
  }

  return new Error(original || "Could not record app activity.");
}

function normalizeStudent(row = {}) {
  return {
    id: row.id || row.student_id || row.studentId || "",
    accountId: row.account_id || "",
    campusStudentId: row.campus_student_id || row.campusStudentId || "",
    accountSource: row.campus_student_id || row.campusStudentId ? "campus" : "local",
    displayName: row.display_name || "",
    loginName: row.login_name || "",
    pin: row.pin_code || "",
    requiresPinReset: row.require_pin_reset === true || row.requirePinReset === true || row.pin_code === DEFAULT_STUDENT_DEVICE_PIN,
    gradeLevel: row.grade_level || "",
    themeColor: getEffectiveStudentThemeColor(
      row.theme_color || row.themeColor,
      row.accountBrandColor || row.account_brand_color
    ),
    profileImageUrl: row.profile_image_url || row.profileImageUrl || "",
    isActive: row.is_active !== false,
  };
}

function normalizeTeacher(row = {}) {
  return {
    id: row.id || "",
    accountId: row.account_id || "",
    linkedUserId: row.linked_user_id || "",
    displayName: row.display_name || row.displayName || "",
    username: row.username || row.login_name || "",
    email: row.email || "",
    role: row.role || "teacher",
    requirePasswordReset: row.require_password_reset === true || row.requirePasswordReset === true,
    gradeLevel: row.grade_level || row.gradeLevel || "",
    location: row.location || "",
    profileImageUrl: row.profile_image_url || row.profileImageUrl || "",
    isActive: row.is_active !== false,
  };
}

export function getEduTeacherSessionToken() {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(TEACHER_SESSION_STORAGE_KEY) || "";
}

export function clearEduTeacherSessionToken() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(TEACHER_SESSION_STORAGE_KEY);
}

function requireEduTeacherSessionToken() {
  const token = getEduTeacherSessionToken();
  if (!token) {
    throw new Error("Teacher login is required.");
  }
  return token;
}

function normalizeTeacherSchool(data = {}) {
  const account = data?.account || data || {};
  const normalizedAccount = normalizeEduAccount({
    id: account.id,
    name: account.name,
    logo_url: account.logoUrl || account.logo_url || "",
    brand_color: account.brandColor || account.brand_color || "",
    deviceBackground: account.deviceBackground || {},
    deviceLoginBackground: account.deviceLoginBackground || {},
    campusLoginBackground: account.campusLoginBackground || account.campus_login_background || {},
    hallPassSettings: account.hallPassSettings || account.hall_pass_settings || {},
    edu_device_code: account.deviceCode || account.edu_device_code || "",
  });

  return normalizedAccount
    ? {
        account: {
          ...normalizedAccount,
          logoUrl: normalizedAccount.logo_url || account.logoUrl || "",
          brandColor: normalizedAccount.brand_color || account.brandColor || "",
          campusLoginBackground: account.campusLoginBackground || account.campus_login_background || {},
          teacherLoginUrl: account.teacherLoginUrl || "",
          portalUrls: account.portalUrls || account.portal_urls || {},
        },
      }
    : null;
}

function normalizeTeacherStudent(row = {}) {
  return {
    teacherId: row.teacher_id || "",
    studentId: row.student_id || "",
  };
}

function normalizeTeacherGroup(row = {}) {
  return {
    id: row.id || "",
    teacherId: row.teacher_id || "",
    name: row.name || "",
    color: row.color || DEVICE_BRAND_COLOR,
    sortOrder: Number(row.sort_order || row.sortOrder || 0),
  };
}

function normalizeTeacherGroupStudent(row = {}) {
  return {
    groupId: row.group_id || row.groupId || "",
    studentId: row.student_id || row.studentId || "",
  };
}

function normalizeSession(row = {}) {
  const lastSeen = row.last_seen_at ? new Date(row.last_seen_at) : null;
  const secondsAgo = lastSeen ? Math.round((Date.now() - lastSeen.getTime()) / 1000) : null;

  return {
    id: row.id || "",
    studentId: row.student_id || "",
    deviceName: row.device_name || "Student device",
    activeAppId: row.active_app_id || "",
    activeUrl: row.active_url || "",
    deviceInfo: row.device_info || row.deviceInfo || {},
    lastSeenAt: row.last_seen_at || "",
    isOnline: typeof secondsAgo === "number" && secondsAgo < 90,
  };
}

function normalizeDevice(row = {}) {
  const lastSeen = row.last_seen_at ? new Date(row.last_seen_at) : null;
  const secondsAgo = lastSeen ? Math.round((Date.now() - lastSeen.getTime()) / 1000) : null;

  return {
    id: row.id || row.device_id || row.deviceId || "",
    accountId: row.account_id || "",
    deviceToken: row.device_token || "",
    studentId: row.last_student_id || "",
    sessionId: row.active_session_id || "",
    deviceName: row.device_name || "Student device",
    activeAppId: row.active_app_id || "",
    activeUrl: row.active_url || "",
    deviceInfo: row.device_info || row.deviceInfo || {},
    lastSeenAt: row.last_seen_at || "",
    createdAt: row.created_at || "",
    updatedAt: row.updated_at || "",
    isOnline: typeof secondsAgo === "number" && secondsAgo < 90,
  };
}

function normalizeAppActivity(row = {}) {
  return {
    id: row.id || "",
    accountId: row.account_id || row.accountId || "",
    studentId: row.student_id || row.studentId || "",
    sessionId: row.session_id || row.sessionId || "",
    deviceId: row.device_id || row.deviceId || "",
    appId: row.app_id || row.appId || "",
    appName: row.app_name || row.appName || "Unknown app",
    launchUrl: row.launch_url || row.launchUrl || "",
    deviceName: row.device_name || row.deviceName || "Student device",
    clickedAt: row.clicked_at || row.clickedAt || "",
  };
}

function normalizeDeviceLoginHistory(row = {}) {
  return {
    id: row.id || "",
    accountId: row.account_id || row.accountId || "",
    deviceId: row.device_id || row.deviceId || "",
    studentId: row.student_id || row.studentId || "",
    sessionId: row.session_id || row.sessionId || "",
    deviceName: row.device_name || row.deviceName || "Student device",
    studentName: row.student_name || row.studentName || "Unknown student",
    loginName: row.login_name || row.loginName || "",
    loggedInAt: row.logged_in_at || row.loggedInAt || "",
  };
}

function normalizeScreenNotification(row = {}) {
  return {
    id: row.id || "",
    title: row.title || "",
    message: row.message || "",
    senderName: row.senderName || row.sender_name || "School",
    createdAt: row.createdAt || row.created_at || "",
  };
}

async function findEduAccountForUser(userId, cachedAccount, organizationAccess = null) {
  const access = organizationAccess || await fetchOrganizationAccess(userId, EDU_MODE);
  let account = normalizeEduAccount(access?.account || null);

  if (account?.id) {
    return account;
  }

  if (cachedAccount?.id) {
    const { data: cachedFreshAccount, error: cachedFreshError } = await supabase
      .from(ACCOUNTS_TABLE)
        .select("id, name, type, owner_user_id, invite_code, logo_url, logo_path, brand_color, edu_device_code, integrations")
      .eq("id", cachedAccount.id)
      .maybeSingle();

    if (!cachedFreshError && cachedFreshAccount?.type === EDU_MODE) {
      return normalizeEduAccount(cachedFreshAccount);
    }

    if (cachedAccount.type === EDU_MODE || !cachedAccount.type) {
      return normalizeEduAccount(cachedAccount);
    }
  }

  const { data: ownedAccounts, error: ownedError } = await supabase
    .from(ACCOUNTS_TABLE)
    .select("id, name, type, owner_user_id, invite_code, logo_url, logo_path, brand_color, edu_device_code, integrations")
    .eq("owner_user_id", userId)
    .eq("type", EDU_MODE)
    .limit(1);

  if (ownedError) {
    throw ownedError;
  }

  account = normalizeEduAccount((ownedAccounts || [])[0] || null);
  if (account?.id) {
    return account;
  }

  const { data: memberships, error: membershipError } = await supabase
    .from("account_members")
    .select("account_id")
    .eq("user_id", userId)
    .eq("status", "active");

  if (membershipError) {
    throw membershipError;
  }

  const accountIds = (memberships || []).map((membership) => membership.account_id);
  if (accountIds.length === 0) {
    return null;
  }

  const { data: memberAccounts, error: memberAccountsError } = await supabase
    .from(ACCOUNTS_TABLE)
    .select("id, name, type, owner_user_id, invite_code, logo_url, logo_path, brand_color, edu_device_code, integrations")
    .in("id", accountIds)
    .eq("type", EDU_MODE)
    .limit(1);

  if (memberAccountsError) {
    throw memberAccountsError;
  }

  return normalizeEduAccount((memberAccounts || [])[0] || null);
}

export function getStudentDeviceEnrollment() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem("oikos.edu.studentDevice.enrollment");
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

export function saveStudentDeviceEnrollment(enrollment) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem("oikos.edu.studentDevice.enrollment", JSON.stringify(enrollment));
}

export function clearStudentDeviceEnrollment() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem("oikos.edu.studentDevice.enrollment");
}

export function getStudentDeviceSession() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem("oikos.edu.studentDevice.session");
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

export function saveStudentDeviceSession(session) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem("oikos.edu.studentDevice.session", JSON.stringify(session));
}

export function clearStudentDeviceSession() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem("oikos.edu.studentDevice.session");
}

export async function loadEduStudentDeviceAdmin(userId) {
  if (!userId) {
    return { account: null, apps: [], students: [], sessions: [], members: [] };
  }

  const cachedAccount = getCachedEduAccount();
  const organizationAccess = await fetchOrganizationAccess(userId, EDU_MODE);
  const account = await findEduAccountForUser(userId, cachedAccount, organizationAccess);

  if (!account?.id) {
    return { account: null, apps: [], students: [], sessions: [], members: [] };
  }

  const appActivityCutoff = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString();
  try {
    await supabase.rpc("edu_student_device_prune_app_activity");
  } catch (pruneError) {
    console.warn("EDU student app activity pruning unavailable. Run the latest SQL migration to enable activity retention.", pruneError);
  }

  const [
    { data: accountRows, error: accountError },
    appsResult,
    systemAppsResult,
    installedAppsResult,
    studentsResult,
    sessionsResult,
    devicesResult,
    appActivityResult,
    deviceLoginHistoryResult,
    teachersResult,
    teacherStudentsResult,
    hallPassRequestsResult,
    testingCatalogResult,
    platformBrandAssets,
  ] =
    await Promise.all([
      supabase
        .from(ACCOUNTS_TABLE)
        .select("id, name, invite_code, logo_url, brand_color, edu_device_code, integrations")
        .eq("id", account.id)
        .maybeSingle(),
      supabase
        .from(APPS_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("sort_order", { ascending: true })
        .order("name", { ascending: true }),
      supabase
        .from(SYSTEM_APPS_TABLE)
        .select("*")
        .eq("is_globally_enabled", true)
        .order("sort_order", { ascending: true })
        .order("name", { ascending: true }),
      supabase
        .from(INSTALLED_APPS_TABLE)
        .select("app_id, student_id, sort_order, installed_at"),
      supabase
        .from(STUDENTS_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("display_name", { ascending: true }),
      supabase
        .from(SESSIONS_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("last_seen_at", { ascending: false })
        .limit(40),
      supabase
        .from(DEVICES_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("last_seen_at", { ascending: false })
        .limit(80),
      supabase
        .from(APP_ACTIVITY_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .gte("clicked_at", appActivityCutoff)
        .order("clicked_at", { ascending: false })
        .limit(2000),
      supabase
        .from(DEVICE_LOGIN_HISTORY_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("logged_in_at", { ascending: false })
        .limit(400),
      supabase
        .from(TEACHERS_TABLE)
        .select("*")
        .eq("account_id", account.id)
        .order("display_name", { ascending: true }),
      supabase
        .from(TEACHER_STUDENTS_TABLE)
        .select("teacher_id, student_id"),
      supabase
        .from(HALL_PASS_REQUESTS_TABLE)
        .select("*, student:edu_student_device_students(display_name), teacher:edu_teachers(display_name)")
        .eq("account_id", account.id)
        .order("created_at", { ascending: false })
        .limit(80),
      supabase
        .from(TESTING_CATALOG_TABLE)
        .select("id, name, type, launch_url, launch_mode, logo_url, description, sort_order")
        .eq("is_globally_enabled", true)
        .order("sort_order", { ascending: true })
        .order("name", { ascending: true }),
      fetchPlatformBrandAssets(),
    ]);

  if (accountError) throw accountError;
  if (appsResult.error) throw appsResult.error;
  if (systemAppsResult.error) throw systemAppsResult.error;
  if (installedAppsResult.error) throw installedAppsResult.error;
  if (studentsResult.error) throw studentsResult.error;
  if (sessionsResult.error) throw sessionsResult.error;
  if (devicesResult.error) throw devicesResult.error;
  if (appActivityResult.error) {
    console.warn("EDU student app activity unavailable. Run the latest SQL migration to enable app history.", appActivityResult.error);
  }
  if (deviceLoginHistoryResult.error) {
    console.warn("EDU device login history unavailable. Run the latest SQL migration to enable device history.", deviceLoginHistoryResult.error);
  }
  if (teachersResult.error) throw teachersResult.error;
  if (teacherStudentsResult.error) throw teacherStudentsResult.error;
  if (hallPassRequestsResult.error) {
    console.warn("EDU hall pass requests unavailable. Run the latest SQL migration to enable hall passes.", hallPassRequestsResult.error);
  }
  if (testingCatalogResult.error) {
    console.warn("EDU testing app catalog unavailable, using built-in defaults:", testingCatalogResult.error);
  }

  const normalizedAccount = normalizeEduAccount({
    ...account,
    ...accountRows,
    testingApps: testingCatalogResult.error ? undefined : testingCatalogResult.data,
  });
  const teachers = (teachersResult.data || []).map(normalizeTeacher);
  const teacherIds = new Set(teachers.map((teacher) => teacher.id));
  const students = (studentsResult.data || []).map((student) =>
    normalizeStudent({
      ...student,
      accountBrandColor: normalizedAccount.brand_color,
    })
  );
  const studentIds = new Set(students.map((student) => student.id));
  const apps = (appsResult.data || []).map((app) => normalizeApp(app, platformBrandAssets));
  const systemAppRows = [...(systemAppsResult.data || [])];
  if (!systemAppRows.some((app) => app?.app_key === "oikos-mail" || app?.appKey === "oikos-mail")) {
    systemAppRows.push(OIKOS_MAIL_SYSTEM_APP);
  }
  if (!systemAppRows.some((app) => app?.app_key === "oikos-pages" || app?.appKey === "oikos-pages")) {
    systemAppRows.push(OIKOS_PAGES_SYSTEM_APP);
  }
  if (!systemAppRows.some((app) => app?.app_key === "oikos-tables" || app?.appKey === "oikos-tables")) {
    systemAppRows.push(OIKOS_TABLES_SYSTEM_APP);
  }
  if (!systemAppRows.some((app) => app?.app_key === "oikos-classroom" || app?.appKey === "oikos-classroom")) {
    systemAppRows.push(OIKOS_CLASSROOM_SYSTEM_APP);
  }
  if (!systemAppRows.some((app) => app?.app_key === "hall-pass" || app?.appKey === "hall-pass")) {
    systemAppRows.push(HALL_PASS_SYSTEM_APP);
  }
  const systemApps = systemAppRows
    .map((app) => normalizeApp({ ...app, is_system: true, source: "system" }, platformBrandAssets))
    .filter((app) => isSystemAppVisibleForAccount(app, normalizedAccount));
  const appNameById = new Map([...apps, ...systemApps].map((app) => [app.id, app.name]));
  const installedApps = (installedAppsResult.data || [])
    .filter((item) => item?.app_id && studentIds.has(item.student_id))
    .map((item) => ({
      appId: item.app_id || "",
      appName: appNameById.get(item.app_id) || "Unknown app",
      studentId: item.student_id || "",
      sortOrder: Number(item.sort_order || 0),
      installedAt: item.installed_at || "",
    }))
    .sort((first, second) => first.sortOrder - second.sortOrder || first.appName.localeCompare(second.appName));
  const installedAppCounts = new Map();
  installedApps.forEach((item) => {
    if (!item?.appId) return;
    installedAppCounts.set(item.appId, (installedAppCounts.get(item.appId) || 0) + 1);
  });
  const appInstallAnalytics = Array.from(installedAppCounts.entries())
    .map(([appId, installCount]) => ({
      appId,
      appName: appNameById.get(appId) || "Unknown app",
      installCount,
    }))
    .sort((a, b) => b.installCount - a.installCount || a.appName.localeCompare(b.appName));

  return {
    account: normalizedAccount,
    apps,
    systemApps,
    appInstallAnalytics,
    installedApps,
    students,
    sessions: (sessionsResult.data || []).map(normalizeSession),
    devices: (devicesResult.data || []).map(normalizeDevice),
    appActivity: appActivityResult.error ? [] : (appActivityResult.data || []).map(normalizeAppActivity),
    deviceLoginHistory: deviceLoginHistoryResult.error ? [] : (deviceLoginHistoryResult.data || []).map(normalizeDeviceLoginHistory),
    teachers,
    teacherStudents: (teacherStudentsResult.data || [])
      .map(normalizeTeacherStudent)
      .filter((item) => teacherIds.has(item.teacherId)),
    hallPassRequests: hallPassRequestsResult.error
      ? []
      : (hallPassRequestsResult.data || []).map((row) => normalizeHallPassRequest({
          ...row,
          student_name: row.student?.display_name,
          teacher_name: row.teacher?.display_name,
        })),
    members: organizationAccess?.account?.id === account.id ? organizationAccess.members || [] : [],
    isOwner: organizationAccess?.account?.id === account.id ? organizationAccess.isOwner === true : false,
    membership: organizationAccess?.account?.id === account.id ? organizationAccess.membership || null : null,
  };
}

export async function loadWorkspacePagesAnalytics(accountId = "") {
  const cleanAccountId = String(accountId || "").trim();
  if (!UUID_PATTERN.test(cleanAccountId)) {
    return { fileCount: 0 };
  }

  const { count, error } = await supabase
    .from(PAGES_DOCUMENTS_TABLE)
    .select("id", { count: "exact", head: true })
    .eq("account_id", cleanAccountId);

  if (error) {
    console.warn("Workspace Pages analytics unavailable. Run the latest Pages SQL to enable file counts.", error);
    return { fileCount: 0 };
  }

  return { fileCount: Number(count || 0) };
}

export async function loadEduHallPassAdminWorkspace(schoolCode = "") {
  const cleanCode = String(schoolCode || "").trim().toUpperCase();
  const { data, error } = await supabase.rpc("edu_hall_pass_admin_workspace", {
    p_school_code: cleanCode,
  });

  if (error) throw error;

  return {
    account: normalizeEduAccount(data?.account || {}),
    students: data?.students || [],
    devices: (data?.devices || []).map((row) => {
      const lastSeen = row.lastSeenAt ? new Date(row.lastSeenAt) : null;
      const secondsAgo = lastSeen ? Math.round((Date.now() - lastSeen.getTime()) / 1000) : null;
      return {
        id: row.id || "",
        studentId: row.studentId || "",
        deviceName: row.deviceName || "Student device",
        activeUrl: row.activeUrl || "",
        activeAppId: row.activeAppId || "",
        lastSeenAt: row.lastSeenAt || "",
        isOnline: typeof secondsAgo === "number" && secondsAgo < 90,
      };
    }),
    hallPassRequests: (data?.hallPassRequests || []).map(normalizeHallPassRequest),
  };
}

export async function saveEduHallPassAdminSettings(schoolCode = "", settings = {}) {
  const cleanCode = String(schoolCode || "").trim().toUpperCase();
  const destinations = Array.isArray(settings.destinations)
    ? settings.destinations.map((destination) => String(destination || "").trim()).filter(Boolean)
    : DEFAULT_HALL_PASS_SETTINGS.destinations;
  const schools = Array.isArray(settings.schools)
    ? settings.schools.map((schoolName) => String(schoolName || "").trim()).filter(Boolean)
    : [];

  const { data, error } = await supabase.rpc("edu_hall_pass_admin_save_settings", {
    p_school_code: cleanCode,
    p_school_name: "",
    p_enabled: settings.enabled === true,
    p_destinations: destinations,
    p_school_names: schools,
    p_require_reason: settings.requireReason === true,
    p_allow_student_cancel: settings.allowStudentCancel !== false,
    p_campus_enabled: settings.campusEnabled === true,
    p_campus_launch_url: "",
  });

  if (error) throw error;

  return {
    account: normalizeEduAccount(data?.account || {}),
    students: data?.students || [],
    devices: (data?.devices || []).map((row) => {
      const lastSeen = row.lastSeenAt ? new Date(row.lastSeenAt) : null;
      const secondsAgo = lastSeen ? Math.round((Date.now() - lastSeen.getTime()) / 1000) : null;
      return {
        id: row.id || "",
        studentId: row.studentId || "",
        deviceName: row.deviceName || "Student device",
        activeUrl: row.activeUrl || "",
        activeAppId: row.activeAppId || "",
        lastSeenAt: row.lastSeenAt || "",
        isOnline: typeof secondsAgo === "number" && secondsAgo < 90,
      };
    }),
    hallPassRequests: (data?.hallPassRequests || []).map(normalizeHallPassRequest),
  };
}

export async function ensureEduDeviceCode(accountId) {
  const generated = Math.random().toString(36).slice(2, 10).toUpperCase();
  const { data, error } = await supabase
    .from(ACCOUNTS_TABLE)
    .update({ edu_device_code: generated })
    .eq("id", accountId)
    .select("edu_device_code")
    .single();

  if (error) throw error;
  return data?.edu_device_code || generated;
}

export async function saveEduDeviceBackground(account, background = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        background: {
          imageUrl: String(background.imageUrl || "").trim(),
          color: String(background.color || DEFAULT_DEVICE_BACKGROUND.color).trim(),
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduDeviceLoginBackground(account, background = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        loginBackground: {
          imageUrl: String(background.imageUrl || "").trim(),
          color: String(background.color || DEFAULT_LOGIN_BACKGROUND.color).trim(),
          useDeviceBackground: background.useDeviceBackground !== false,
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function uploadEduDeviceBackgroundImage(account, file) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  if (!file) {
    throw new Error("Choose an image to upload.");
  }

  if (!String(file.type || "").startsWith("image/")) {
    throw new Error("Background upload must be an image file.");
  }

  const safeName = file.name.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9._-]/g, "").toLowerCase();
  const filePath = `${account.id}/edu-device-backgrounds/${Date.now()}-${safeName || "background"}`;

  const { error: uploadError } = await supabase.storage
    .from(ORGANIZATION_BUCKET)
    .upload(filePath, file, {
      cacheControl: "3600",
      upsert: false,
    });

  if (uploadError) {
    throw uploadError;
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from(ORGANIZATION_BUCKET).getPublicUrl(filePath);

  return publicUrl;
}

export async function uploadEduDeviceAppLogo(account, file) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  if (!file) {
    throw new Error("Choose an image to upload.");
  }

  if (!String(file.type || "").startsWith("image/")) {
    throw new Error("Logo upload must be an image file.");
  }

  const safeName = file.name.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9._-]/g, "").toLowerCase();
  const filePath = `${account.id}/edu-device-app-logos/${Date.now()}-${safeName || "app-logo"}`;

  const { error: uploadError } = await supabase.storage
    .from(ORGANIZATION_BUCKET)
    .upload(filePath, file, {
      cacheControl: "3600",
      upsert: false,
    });

  if (uploadError) {
    throw uploadError;
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from(ORGANIZATION_BUCKET).getPublicUrl(filePath);

  return publicUrl;
}

export async function saveEduDeviceDockTiles(account, appIds = []) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        dockAppIds: appIds.filter(Boolean).slice(0, MAX_DEVICE_DOCK_APP_IDS),
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduDeviceSecuritySettings(account, settings = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const idleLogoutMinutes = Math.max(
    0,
    Math.min(240, Number(settings.idleLogoutMinutes || 0))
  );
  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        idleLogoutMinutes,
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduChromeExtensionSettings(account, settings = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const allowedHosts = Array.isArray(settings.allowedHosts)
    ? settings.allowedHosts.map((host) => String(host || "").trim().toLowerCase()).filter(Boolean)
    : [];

  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        chromeExtension: {
          enabled: settings.enabled !== false,
          oikosHomeUrl: String(settings.oikosHomeUrl || "").trim(),
          googleCustomerId: String(settings.googleCustomerId || "").trim(),
          googleAdminEmail: String(settings.googleAdminEmail || "").trim().toLowerCase(),
          googleOrgUnitPath: String(settings.googleOrgUnitPath || "").trim(),
          extensionId: String(settings.extensionId || "").trim(),
          extensionUpdateUrl: String(settings.extensionUpdateUrl || "https://clients2.google.com/service/update2/crx").trim(),
          allowedHosts: Array.from(new Set(allowedHosts)),
          blockUnknownHosts: settings.blockUnknownHosts !== false,
          overlayEnabled: settings.overlayEnabled !== false,
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduTestingApps(account, testingApps = []) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const normalizedApps = mergeDefaultTestingApps(testingApps);
  const testingAppSettings = normalizedApps.map((app) => ({
    id: app.id,
    isActive: app.isActive === true,
  }));

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        testingAppSettings,
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduHallPassSettings(account, settings = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const destinations = Array.isArray(settings.destinations)
    ? settings.destinations.map((destination) => String(destination || "").trim()).filter(Boolean)
    : DEFAULT_HALL_PASS_SETTINGS.destinations;

  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        hallPass: {
          enabled: settings.enabled === true,
          destinations: destinations.length ? destinations.slice(0, 20) : DEFAULT_HALL_PASS_SETTINGS.destinations,
          requireReason: settings.requireReason === true,
          allowStudentCancel: settings.allowStudentCancel !== false,
          dailyPassLimit: normalizeLimit(settings.dailyPassLimit, DEFAULT_HALL_PASS_SETTINGS.dailyPassLimit),
          activePassLimit: normalizeLimit(settings.activePassLimit, DEFAULT_HALL_PASS_SETTINGS.activePassLimit),
          campusEnabled: settings.campusEnabled === true,
          campusLaunchUrl: String(settings.campusLaunchUrl || "").trim(),
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduExtrasSettings(account, settings = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const deviceCode = String(account.deviceCode || account.edu_device_code || "").trim().toUpperCase();
  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const currentHallPass = {
    ...DEFAULT_HALL_PASS_SETTINGS,
    ...(eduStudentDevice.hallPass || account.hallPassSettings || {}),
  };
  const extras = {
    notificationsEnabled: true,
    managedDevicesEnabled: settings.managedDevicesEnabled !== false,
    hallPassEnabled: settings.workspaceEnabled === true || settings.hallPassEnabled === true,
    classroomEnabled: settings.workspaceEnabled === true || settings.classroomEnabled === true,
    workspaceEnabled: settings.workspaceEnabled === true,
  };
  const integrationSettings = eduStudentDevice.integrations || {};
  const classroomMode = settings.classroomMode === "campus" || settings.classroomCampusSyncEnabled === true
    ? "campus"
    : "standalone";

  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        extras,
        integrations: {
          ...integrationSettings,
          "managed-devices": {
            ...(integrationSettings["managed-devices"] || {}),
            enabled: extras.managedDevicesEnabled,
            adminUrl: "/devices/admin",
            teacherUrl: deviceCode ? `/devices/teacher/${deviceCode}` : "/devices/teacher",
            studentUrl: deviceCode ? `/devices/student/${deviceCode}` : "/devices/student",
          },
          classroom: {
            ...(integrationSettings.classroom || {}),
            enabled: extras.classroomEnabled,
            mode: classroomMode,
            campusSyncEnabled: classroomMode === "campus",
            adminUrl: "/classroom/admin",
            teacherUrl: deviceCode ? `/classroom/teacher/${deviceCode}` : "/classroom/teacher",
            studentUrl: deviceCode ? `/classroom/student/${deviceCode}` : "/classroom/student",
          },
          workspace: {
            ...(integrationSettings.workspace || {}),
            enabled: extras.workspaceEnabled,
            adminUrl: "/workspace/admin",
            pagesUrl: "/pages",
            tablesUrl: "/tables",
            slidesUrl: "/slides",
            mailUrl: "/mail",
          },
        },
        workspace: {
          ...DEFAULT_WORKSPACE_SETTINGS,
          ...(eduStudentDevice.workspace || account.workspaceSettings || {}),
          enabled: extras.workspaceEnabled,
        },
        hallPass: {
          ...currentHallPass,
          enabled: extras.hallPassEnabled,
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduWorkspaceSettings(account, settings = {}) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const integrationSettings = eduStudentDevice.integrations || {};
  const existingWorkspace = eduStudentDevice.workspace || account.workspaceSettings || {};
  const enabled = settings.enabled === true;
  const apps = {
    pages: settings.apps?.pages !== false,
    tables: settings.apps?.tables === true,
    slides: settings.apps?.slides === true,
    mail: settings.apps?.mail === true,
    classroom: settings.apps?.classroom === true,
    hallPass: settings.apps?.hallPass === true,
    teacherBoard: settings.apps?.teacherBoard === true,
  };
  const nextExtras = {
    ...(eduStudentDevice.extras || account.extrasSettings || {}),
    workspaceEnabled: enabled,
    managedDevicesEnabled: settings.managedDevicesEnabled !== false,
    classroomEnabled: apps.classroom,
    hallPassEnabled: apps.hallPass,
  };
  const nextClassroomIntegration = {
    ...(integrationSettings.classroom || account.integrationSettings?.classroom || {}),
    enabled: apps.classroom,
  };
  const currentHallPass = eduStudentDevice.hallPass || account.hallPassSettings || {};
  const workspace = {
    ...DEFAULT_WORKSPACE_SETTINGS,
    ...existingWorkspace,
    enabled,
    apps,
    studentSharing: settings.studentSharing === true,
    teacherTemplates: settings.teacherTemplates !== false,
    adminReview: settings.adminReview !== false,
    pagesStudentCreate: settings.pagesStudentCreate !== false,
    pagesStudentSharing: settings.pagesStudentSharing === true,
    pagesMailSend: settings.pagesMailSend !== false,
    pagesClassroomAttach: settings.pagesClassroomAttach !== false,
    tablesStudentCreate: settings.tablesStudentCreate !== false,
    tablesStudentSharing: settings.tablesStudentSharing === true,
    tablesMailSend: settings.tablesMailSend !== false,
    tablesClassroomAttach: settings.tablesClassroomAttach !== false,
    slidesStudentCreate: settings.slidesStudentCreate !== false,
    slidesStudentSharing: settings.slidesStudentSharing === true,
    slidesMailSend: settings.slidesMailSend !== false,
    slidesClassroomAttach: settings.slidesClassroomAttach !== false,
  };

  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        workspace,
        hallPass: {
          ...currentHallPass,
          enabled: apps.hallPass,
        },
        extras: {
          ...nextExtras,
        },
        integrations: {
          ...integrationSettings,
          classroom: nextClassroomIntegration,
          workspace: {
            ...(integrationSettings.workspace || {}),
            enabled,
            adminUrl: "/workspace/admin",
            pagesUrl: "/pages",
            tablesUrl: "/tables",
            slidesUrl: "/slides",
            mailUrl: "/mail",
            classroomUrl: "/classroom/admin",
            hallPassUrl: "/edu/hallpass/admin",
            teacherBoardAdminUrl: "/workspace/admin?section=teacherBoard",
          },
        },
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function saveEduNotificationTemplates(account, templates = []) {
  if (!account?.id) {
    throw new Error("Missing organization account.");
  }

  const integrations = account.integrations || {};
  const eduStudentDevice = integrations.eduStudentDevice || {};
  const notificationTemplates = normalizeNotificationTemplates(templates).map((template, index) => ({
    ...template,
    sortOrder: index,
  }));

  const nextAccount = await updateOrganizationSettings(account.id, {
    integrations: {
      ...integrations,
      eduStudentDevice: {
        ...eduStudentDevice,
        notificationTemplates,
      },
    },
  });

  return normalizeEduAccount(nextAccount);
}

export async function updateEduHallPassRequest(requestId, status, note = "", options = {}) {
  const teacherToken = getEduTeacherSessionToken();
  const useTeacherSession = options.useTeacherSession !== undefined
    ? options.useTeacherSession === true
    : Boolean(teacherToken);
  const rpcName = useTeacherSession && teacherToken ? "edu_teacher_portal_update_hall_pass_request" : "edu_update_hall_pass_request";
  const rpcPayload = useTeacherSession && teacherToken
    ? {
        p_teacher_session_token: teacherToken,
        p_request_id: requestId,
        p_status: status,
        p_note: note,
      }
    : {
        p_request_id: requestId,
        p_status: status,
        p_note: note,
      };

  const { data, error } = await supabase.rpc(rpcName, rpcPayload);

  if (error) throw error;
  return normalizeHallPassRequest(data || {});
}

export async function syncEduChromeGuardPolicy(accountId) {
  if (!accountId) {
    throw new Error("Missing Edu organization.");
  }

  const { data, error } = await supabase.functions.invoke("sync-edu-chrome-policy", {
    body: {
      accountId,
    },
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function saveEduDeviceApp(accountId, app) {
  const payload = {
    account_id: accountId,
    created_by_teacher_id: null,
    name: String(app.name || "").trim(),
    url: String(app.url || "").trim(),
    logo_url: String(app.logoUrl || "").trim(),
    color: String(app.color || DEVICE_BRAND_COLOR).trim(),
    is_active: app.isActive !== false,
    sort_order: Number(app.sortOrder || 0),
  };

  if (!payload.name || !payload.url) {
    throw new Error("App name and website link are required.");
  }

  const query = app.id
    ? supabase.from(APPS_TABLE).update(payload).eq("id", app.id).select("*").single()
    : supabase.from(APPS_TABLE).insert(payload).select("*").single();

  const { data, error } = await query;
  if (error) throw error;
  return normalizeApp(data);
}

export async function deleteEduDeviceApp(appId) {
  const { error } = await supabase.from(APPS_TABLE).delete().eq("id", appId);
  if (error) throw error;
}

export async function deleteEduSystemDeviceApp(appId) {
  const { error } = await supabase.from(SYSTEM_APPS_TABLE).delete().eq("id", appId);
  if (error) throw error;
}

export async function saveEduDeviceStudent(accountId, student) {
  const pin = String(student.pin || DEFAULT_STUDENT_DEVICE_PIN).trim();
  if (!/^\d{4}$/.test(pin)) {
    throw new Error("Student PIN must be exactly 4 digits.");
  }

  const payload = {
    account_id: accountId,
    display_name: String(student.displayName || "").trim(),
    login_name: normalizeStudentLoginName(student.loginName || student.displayName),
    pin_code: pin,
    require_pin_reset: student.requirePinReset === true,
    grade_level: String(student.gradeLevel || "").trim(),
    theme_color: DEVICE_BRAND_COLOR,
    profile_image_url: String(student.profileImageUrl || "").trim(),
    is_active: student.isActive !== false,
  };

  if (!payload.display_name || !payload.login_name) {
    throw new Error("Student name is required.");
  }

  const query = student.id
    ? supabase.from(STUDENTS_TABLE).update(payload).eq("id", student.id).select("*").single()
    : supabase.from(STUDENTS_TABLE).insert(payload).select("*").single();

  const { data, error } = await query;
  if (error) throw error;
  return normalizeStudent(data);
}

export async function deleteEduDeviceStudent(studentId) {
  const { error } = await supabase.from(STUDENTS_TABLE).delete().eq("id", studentId);
  if (error) throw error;
}

export async function uninstallEduStudentDeviceApp(studentId, appId) {
  const cleanStudentId = String(studentId || "").trim();
  const cleanAppId = String(appId || "").trim();
  if (!UUID_PATTERN.test(cleanStudentId)) {
    throw new Error("Missing student id. Refresh the admin page and try again.");
  }
  if (!cleanAppId) {
    throw new Error("Missing app id. Refresh the admin page and try again.");
  }

  const { data, error } = await supabase.rpc("edu_admin_uninstall_student_device_app", {
    p_student_id: cleanStudentId,
    p_app_id: cleanAppId,
  });

  if (error) throw error;
  return data || {};
}

export async function lockEduStudentDeviceScreen(studentId) {
  const cleanStudentId = String(studentId || "").trim();
  if (!UUID_PATTERN.test(cleanStudentId)) {
    throw new Error("Missing student id.");
  }

  const { data, error } = await supabase.rpc("edu_admin_lock_student_device_screen", {
    p_student_id: cleanStudentId,
  });

  if (error) throw error;
  return data;
}

export async function lockEduStudentDevice(deviceId) {
  const cleanDeviceId = String(deviceId || "").trim();
  if (!UUID_PATTERN.test(cleanDeviceId)) {
    throw new Error("Missing device id.");
  }

  const { data, error } = await supabase.rpc("edu_admin_lock_student_device", {
    p_device_id: cleanDeviceId,
  });

  if (error) throw error;
  return data;
}

export async function saveEduTeacher(accountId, teacher) {
  const { data, error } = await supabase.rpc("edu_admin_save_teacher", {
    p_account_id: accountId,
    p_teacher_id: teacher.id || null,
    p_display_name: teacher.displayName,
    p_username: teacher.username || "",
    p_password: teacher.password || "",
    p_email: teacher.email || "",
    p_grade_level: teacher.gradeLevel || "",
    p_location: teacher.location || "",
    p_is_active: teacher.isActive !== false,
    p_role: teacher.role || "teacher",
    p_require_password_reset: teacher.requirePasswordReset === true,
  });

  if (error) throw error;
  return normalizeTeacher(data);
}

export async function inviteEduTeacherAccount(accountId, teacher) {
  if (!accountId) {
    throw new Error("Missing Edu organization.");
  }

  if (!teacher?.id) {
    throw new Error("Save the teacher before sending an account setup email.");
  }

  if (!teacher?.email) {
    throw new Error("Teacher email is required.");
  }

  const { data, error } = await supabase.functions.invoke("send-edu-teacher-invite", {
    body: {
      accountId,
      teacherId: teacher.id,
      email: teacher.email,
      teacherName: teacher.displayName || "",
      redirectTo: `${getEduAppOrigin()}/reset-password`,
    },
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);

  return data;
}

export async function deleteEduTeacher(teacherId) {
  const { error } = await supabase.from(TEACHERS_TABLE).delete().eq("id", teacherId);
  if (error) throw error;
}

export async function getEduTeacherPortalSchool(schoolCode) {
  const cleanCode = String(schoolCode || "").trim().toUpperCase();
  if (!cleanCode) {
    throw new Error("School code is required.");
  }

  const { data, error } = await supabase.rpc("edu_teacher_portal_get_school", {
    p_school_code: cleanCode,
  });

  if (error) throw error;
  return normalizeTeacherSchool(data);
}

export async function submitManagedDevicesAccountRequest(request = {}) {
  const { data, error } = await supabase.rpc("edu_managed_devices_submit_account_request", {
    p_requester_name: request.requesterName || "",
    p_requester_email: request.requesterEmail || "",
    p_requester_phone: request.requesterPhone || "",
    p_requester_role: request.requesterRole || "",
    p_organization_name: request.organizationName || "",
    p_organization_website: request.organizationWebsite || "",
    p_organization_location: request.organizationLocation || "",
    p_estimated_devices: request.estimatedDevices || "",
    p_notes: request.notes || "",
  });

  if (error) throw error;
  return data || {};
}

export async function loginEduTeacherPortal({ schoolCode, username, password }) {
  await getEduTeacherPortalSchool(schoolCode);

  const cleanUsername = String(username || "").trim().toLowerCase();
  if (!cleanUsername) {
    throw new Error("Teacher username is required.");
  }
  if (!password) {
    throw new Error("Password is required.");
  }

  const { data, error } = await supabase.rpc("edu_teacher_portal_login", {
    p_school_code: schoolCode,
    p_username: cleanUsername,
    p_password: password,
  });

  if (error) throw error;
  const sessionToken = data?.sessionToken || data?.session_token || "";
  if (sessionToken && typeof window !== "undefined") {
    window.localStorage.setItem(TEACHER_SESSION_STORAGE_KEY, sessionToken);
  }
  return data;
}

export async function sendEduTeacherPasswordReset(teacher, schoolCode = "") {
  if (!teacher?.email) {
    throw new Error("This teacher does not have an email address.");
  }

  const cleanEmail = String(teacher.email || "").trim().toLowerCase();
  const cleanCode = String(schoolCode || "").trim().toUpperCase();

  if (cleanCode) {
    const { data, error } = await supabase.rpc("edu_teacher_portal_validate_reset_email", {
      p_school_code: cleanCode,
      p_email: cleanEmail,
    });

    if (error) throw error;
    if (data?.isEligible !== true) return { sent: false };
  }

  const { error } = await supabase.auth.resetPasswordForEmail(cleanEmail, {
    redirectTo: `${getEduAppOrigin()}/reset-password`,
  });

  if (error) throw error;
  return { sent: true };
}

export async function requestEduTeacherPasswordReset({ schoolCode, email }) {
  const cleanEmail = String(email || "").trim().toLowerCase();
  if (!cleanEmail) {
    throw new Error("Teacher email is required.");
  }

  await sendEduTeacherPasswordReset({ email: cleanEmail }, schoolCode);
  return { ok: true };
}

export async function changeEduTeacherPortalPassword({ currentPassword, newPassword }) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_change_password", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_current_password: currentPassword || "",
    p_new_password: newPassword || "",
  });

  if (error) throw error;
  return data;
}

export async function saveEduTeacherPortalProfile(profile = {}) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_save_profile", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_display_name: profile.displayName || "",
    p_email: profile.email || "",
    p_grade_level: profile.gradeLevel || "",
    p_location: profile.location || "",
    p_profile_image_url: profile.profileImageUrl || "",
  });

  if (error) throw error;
  return data;
}

export async function saveEduTeacherStudents(teacherId, studentIds) {
  const { data, error } = await supabase.rpc("edu_admin_set_teacher_students", {
    p_teacher_id: teacherId,
    p_student_ids: studentIds,
  });

  if (error) throw error;
  return data;
}

export async function loadEduTeacherPortalWorkspace() {
  const { data, error } = await supabase.rpc("edu_teacher_portal_workspace", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
  });
  if (error) throw error;

  const devices = (data?.devices || []).map((row) => {
    const lastSeen = row.lastSeenAt ? new Date(row.lastSeenAt) : null;
    const secondsAgo = lastSeen ? Math.round((Date.now() - lastSeen.getTime()) / 1000) : null;
    return {
      id: row.id || "",
      studentId: row.studentId || "",
      deviceName: row.deviceName || "Student device",
      activeUrl: row.activeUrl || "",
      activeAppId: row.activeAppId || "",
      lastSeenAt: row.lastSeenAt || "",
      isOnline: typeof secondsAgo === "number" && secondsAgo < 90,
    };
  });

  return {
    account: normalizeEduAccount(data?.account || {}),
    teacher: data?.teacher ? normalizeTeacher(data.teacher) : null,
    apps: (data?.apps || []).map(normalizeApp),
    students: data?.students || [],
    availableStudents: data?.availableStudents || [],
    groups: (data?.groups || []).map(normalizeTeacherGroup),
    groupStudents: (data?.groupStudents || []).map(normalizeTeacherGroupStudent),
    hallPassRequests: (data?.hallPassRequests || []).map(normalizeHallPassRequest),
    devices,
  };
}

export async function saveEduTeacherDeviceApp(app) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_save_app", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_app_id: app.id || null,
    p_name: app.name || "",
    p_url: app.url || "",
    p_logo_url: app.logoUrl || "",
    p_color: app.color || DEVICE_BRAND_COLOR,
    p_is_active: app.isActive !== false,
  });

  if (error) throw error;
  return normalizeApp(data || {});
}

export async function deleteEduTeacherDeviceApp(appId) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_delete_app", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_app_id: appId,
  });

  if (error) throw error;
  return data;
}

export async function updateEduTeacherStudentPin(studentId, pin) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_set_student_pin", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_student_id: studentId,
    p_pin: pin,
  });

  if (error) throw error;
  return data;
}

export async function addEduTeacherStudent(studentId) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_add_student", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_student_id: studentId,
  });

  if (error) throw error;
  return data;
}

export async function removeEduTeacherStudent(studentId) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_remove_student", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_student_id: studentId,
  });

  if (error) throw error;
  return data;
}

export async function saveEduTeacherClassGroup(group) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_save_group", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_group_id: group.id || null,
    p_name: group.name || "",
    p_color: group.color || DEVICE_BRAND_COLOR,
    p_student_ids: group.studentIds || [],
  });

  if (error) throw error;
  return normalizeTeacherGroup(data || {});
}

export async function deleteEduTeacherClassGroup(groupId) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_delete_group", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_group_id: groupId,
  });

  if (error) throw error;
  return data;
}

export async function removeEduStudentDevice(deviceId) {
  const { error } = await supabase.rpc("edu_admin_remove_student_device", {
    target_device_id: deviceId,
  });

  if (error) throw error;
}

export async function runEduStudentDeviceEndOfYearCleanup(accountId) {
  if (!accountId) {
    throw new Error("Missing Edu organization.");
  }

  const cutoff = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString();

  const { data: resetStudents, error: resetError } = await supabase
    .from(STUDENTS_TABLE)
    .update({ pin_code: DEFAULT_STUDENT_DEVICE_PIN })
    .eq("account_id", accountId)
    .select("id");

  if (resetError) throw resetError;

  const { data: staleDevices, error: staleDevicesError } = await supabase
    .from(DEVICES_TABLE)
    .select("id")
    .eq("account_id", accountId)
    .lt("last_seen_at", cutoff);

  if (staleDevicesError) throw staleDevicesError;

  let devicesRemoved = 0;
  for (const device of staleDevices || []) {
    await removeEduStudentDevice(device.id);
    devicesRemoved += 1;
  }

  return {
    pinsReset: Array.isArray(resetStudents) ? resetStudents.length : 0,
    devicesRemoved,
  };
}

export async function renameEduStudentDevice(deviceId, deviceName) {
  const { data, error } = await supabase.rpc("edu_admin_rename_student_device", {
    target_device_id: deviceId,
    target_device_name: deviceName,
  });

  if (error) throw error;
  return normalizeDevice(data || {});
}

export async function enrollEduStudentDevice({ schoolCode, deviceName }) {
  const { data, error } = await supabase.rpc("edu_student_device_enroll", {
    p_school_code: schoolCode,
    p_device_name: deviceName,
  });

  if (error) throw error;
  return data;
}

export async function refreshEduStudentDeviceEnrollment(deviceToken) {
  if (!deviceToken) {
    throw new Error("Missing device enrollment.");
  }

  const { data, error } = await supabase.rpc("edu_student_device_get_enrollment", {
    p_device_token: deviceToken,
  });

  if (error) throw error;
  return data;
}

export async function loginEduStudentDevice({ schoolCode, studentName, pin, deviceName, deviceToken }) {
  const [loginResult, platformBrandAssets] = await Promise.all([
    supabase.rpc("edu_student_device_login", {
      p_school_code: schoolCode,
      p_student_name: studentName,
      p_pin: pin,
      p_device_name: deviceName,
      p_device_token: deviceToken || null,
    }),
    fetchPlatformBrandAssets(),
  ]);
  const { data, error } = loginResult;

  if (error) throw error;
  const classroomEnabled = isClassroomEnabledForStudentDevicePayload(data);
  const mailEnabled = isMailEnabledForStudentDevicePayload(data);
  const pagesEnabled = isPagesEnabledForStudentDevicePayload(data);
  const tablesEnabled = isTablesEnabledForStudentDevicePayload(data);
  return {
    ...(data || {}),
    apps: includeCoreSystemApps(data?.apps || [], data, platformBrandAssets)
      .filter((app) =>
        (app.appKey !== "oikos-classroom" || classroomEnabled) &&
        (app.appKey !== "oikos-mail" || mailEnabled) &&
        (app.appKey !== "oikos-pages" || pagesEnabled) &&
        (app.appKey !== "oikos-tables" || tablesEnabled)
    ),
  };
}

export async function checkEduStudentDeviceDisabledLogin({ schoolCode, studentName, pin }) {
  const { data, error } = await supabase.rpc("edu_student_device_check_disabled_login", {
    p_school_code: schoolCode,
    p_student_name: studentName,
    p_pin: pin,
  });

  if (error) throw error;
  return data?.isDisabled === true || data?.is_disabled === true;
}

export async function recordEduStudentDeviceLogin({ sessionToken, deviceToken, deviceName }) {
  const { data, error } = await supabase.rpc("edu_student_device_record_login", {
    p_session_token: sessionToken,
    p_device_token: deviceToken || null,
    p_device_name: deviceName || "",
  });

  if (error) throw error;
  return data;
}

export async function loadEduStudentDeviceCatalog(sessionToken) {
  const [catalogResult, platformBrandAssets] = await Promise.all([
    supabase.rpc("edu_student_device_get_catalog", {
      p_session_token: sessionToken,
    }),
    fetchPlatformBrandAssets(),
  ]);
  const { data, error } = catalogResult;

  if (error) throw error;
  const classroomEnabled = isClassroomEnabledForStudentDevicePayload(data);
  const mailEnabled = isMailEnabledForStudentDevicePayload(data);
  const pagesEnabled = isPagesEnabledForStudentDevicePayload(data);
  const tablesEnabled = isTablesEnabledForStudentDevicePayload(data);
  return {
    ...(data || {}),
    apps: includeCoreSystemApps(data?.apps || [], data, platformBrandAssets)
      .filter((app) =>
        (app.appKey !== "oikos-classroom" || classroomEnabled) &&
        (app.appKey !== "oikos-mail" || mailEnabled) &&
        (app.appKey !== "oikos-pages" || pagesEnabled) &&
        (app.appKey !== "oikos-tables" || tablesEnabled)
      ),
  };
}

export async function saveEduStudentDeviceDesktop(sessionToken, installedAppIds, themeColor) {
  const desktopLayout = Array.isArray(installedAppIds) ? installedAppIds : [];
  const deviceThemeColor = String(themeColor || DEVICE_BRAND_COLOR).trim();
  const { data, error } = await supabase.rpc("edu_student_device_save_desktop_layout", {
    p_session_token: sessionToken,
    p_desktop_layout: desktopLayout,
    p_theme_color: deviceThemeColor,
  });

  if (!error) return data;

  const hasGroups = desktopLayout.some((item) => item && typeof item === "object");
  if (hasGroups) throw error;

  const fallback = await supabase.rpc("edu_student_device_save_desktop", {
    p_session_token: sessionToken,
    p_installed_app_ids: desktopLayout.filter(Boolean),
    p_theme_color: deviceThemeColor,
  });

  if (fallback.error) throw fallback.error;
  return fallback.data;
}

export async function changeEduStudentDevicePin(sessionToken, currentPin, nextPin) {
  const { data, error } = await supabase.rpc("edu_student_device_change_pin", {
    p_session_token: sessionToken,
    p_current_pin: currentPin,
    p_new_pin: nextPin,
  });

  if (error) throw error;
  return data;
}

export async function sendEduStudentDeviceHeartbeat({
  sessionToken,
  deviceName,
  activeAppId,
  activeUrl,
  deviceToken,
  deviceInfo,
}) {
  const { data, error } = await supabase.rpc("edu_student_device_heartbeat", {
    p_session_token: sessionToken,
    p_device_name: deviceName,
    p_active_app_id: activeAppId || null,
    p_active_url: activeUrl || "",
    p_device_token: deviceToken || null,
    p_device_info: deviceInfo || {},
  });

  if (error) throw error;
  return data;
}

export async function recordEduStudentDeviceAppLaunch({
  sessionToken,
  appId,
  appName,
  launchUrl,
  deviceToken,
  deviceName,
}) {
  if (!sessionToken) {
    throw new Error("App activity was not recorded because the student session token is missing.");
  }

  const { data, error } = await supabase.rpc("edu_student_device_record_app_launch", {
    p_session_token: sessionToken,
    p_app_id: appId || "unknown",
    p_app_name: appName || "Unknown app",
    p_launch_url: launchUrl || "",
    p_device_token: deviceToken || null,
    p_device_name: deviceName || "",
  });

  if (error) throw buildStudentDeviceActivityError(error);
  return data;
}

export async function createEduStudentHallPassRequest(sessionToken, request = {}) {
  const { data, error } = await supabase.rpc("edu_student_device_create_hall_pass_request", {
    p_session_token: sessionToken,
    p_destination: request.destination || "",
    p_note: request.note || "",
  });

  if (error) throw error;
  return normalizeHallPassRequest(data || {});
}

export async function loadEduStudentHallPassRequests(sessionToken) {
  const { data, error } = await supabase.rpc("edu_student_device_get_hall_pass_requests", {
    p_session_token: sessionToken,
  });

  if (error) throw error;
  return Array.isArray(data) ? data.map(normalizeHallPassRequest) : [];
}

export async function markEduStudentHallPassReturned(sessionToken, requestId) {
  const { data, error } = await supabase.rpc("edu_student_device_mark_hall_pass_returned", {
    p_session_token: sessionToken,
    p_request_id: requestId,
  });

  if (error) throw error;
  return normalizeHallPassRequest(data || {});
}

export async function cancelEduStudentHallPassRequest(sessionToken, requestId) {
  const { data, error } = await supabase.rpc("edu_student_device_cancel_hall_pass_request", {
    p_session_token: sessionToken,
    p_request_id: requestId,
  });

  if (error) {
    const message = String(`${error?.message || ""} ${error?.details || ""} ${error?.hint || ""}`).toLowerCase();
    if (message.includes("request_row") && (message.includes("student_name") || message.includes("teacher_name"))) {
      throw new Error("Hall pass cancel needs the latest SQL update. Run sql/edu-student-device-app-activity.sql in Supabase, then try cancelling again.");
    }
    throw error;
  }
  return normalizeHallPassRequest(data || {});
}

export async function loadEduStudentDeviceNotifications(sessionToken) {
  const { data, error } = await supabase.rpc("edu_student_device_get_notifications", {
    p_session_token: sessionToken,
  });

  if (error) throw error;
  return Array.isArray(data) ? data.map(normalizeScreenNotification) : [];
}

export async function dismissEduStudentDeviceNotification(sessionToken, notificationId) {
  const { data, error } = await supabase.rpc("edu_student_device_dismiss_notification", {
    p_session_token: sessionToken,
    p_notification_id: notificationId,
  });

  if (error) throw error;
  return data;
}

export async function sendEduTeacherScreenNotification({
  targetType,
  studentId,
  groupId,
  title,
  message,
}) {
  const { data, error } = await supabase.rpc("edu_teacher_portal_send_notification", {
    p_teacher_session_token: requireEduTeacherSessionToken(),
    p_target_type: targetType || "student",
    p_student_id: targetType === "student" ? studentId || null : null,
    p_group_id: targetType === "group" ? groupId || null : null,
    p_title: title || "",
    p_message: message || "",
  });

  if (error) throw error;
  return data;
}

export async function sendEduAdminScreenNotification({
  accountId,
  targetType,
  studentId,
  title,
  message,
}) {
  const { data, error } = await supabase.rpc("edu_admin_send_student_notification", {
    p_account_id: accountId,
    p_target_type: targetType || "student",
    p_student_id: targetType === "student" ? studentId || null : null,
    p_title: title || "",
    p_message: message || "",
  });

  if (error) throw error;
  return data;
}
